import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/content/assets/menu/categories/full-face.jpg")